/*export default function UserLayout({ user, onlineUsersId }) {
  return (
    <div className="relative flex items-center">
      <img className="w-10 h-10 rounded-full" src={user?.photoURL} alt="" />
      <span className="block ml-2 text-gray-500 dark:text-gray-400">
        {user?.displayName}
      </span>
      {onlineUsersId?.includes(user?.uid) ? (
        <span className="bottom-0 left-7 absolute  w-3.5 h-3.5 bg-green-500 dark:bg-green-400 border-2 border-white rounded-full"></span>
      ) : (
        <span className="bottom-0 left-7 absolute  w-3.5 h-3.5 bg-gray-400 border-2 border-white rounded-full"></span>
      )}
    </div>
  );
}
*/

export default function UserLayout({ user, onlineUsersId, showPhone = false }) {
  const name = user?.displayName || user?.name || "Usuário";
  const phone = user?.uid || user?.phone || "";
  const photo = user?.photoURL || `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random&color=fff&size=40`;
  const isOnline = onlineUsersId?.includes(user?.uid);

  return (
    <div className="relative flex items-center">
      <img className="w-10 h-10 rounded-full" src={photo} alt={name} />
      <div className="ml-2">
        <span className="block text-gray-500 dark:text-gray-400">
          {name}
        </span>
        {showPhone && phone && (
          <span className="block text-sm text-gray-400 dark:text-gray-500">
            {phone}
          </span>
        )}
      </div>
      <span
        className={`bottom-0 left-7 absolute w-3.5 h-3.5 border-2 border-white rounded-full ${
          isOnline ? "bg-green-500 dark:bg-green-400" : "bg-gray-400"
        }`}
      ></span>
    </div>
  );
}